__turbopack_context__.v({
  "error": "index-module-scss-module__PgwipW__error",
  "error-message": "index-module-scss-module__PgwipW__error-message",
  "label": "index-module-scss-module__PgwipW__label",
  "select": "index-module-scss-module__PgwipW__select",
});
